import React from 'react'
import Signin from '../components/Signin'

const SigninPage = () => {
  return (
    <>
      <Signin />
    </>
  )
}

export default SigninPage